import { render } from "./SearchOverlay.vue?vue&type=template&id=6d72bfba"
import script from "./SearchOverlay.vue?vue&type=script&lang=js"
export * from "./SearchOverlay.vue?vue&type=script&lang=js"

import "./SearchOverlay.vue?vue&type=style&index=0&id=6d72bfba&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__